import { Link } from 'react-router-dom';
import { guides } from '@/mocks/categories';

export default function GuidesSection() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 md:mb-16">
          <div>
            <span className="inline-block px-4 py-1.5 rounded-full border border-primary-300/60 bg-primary-100/50 text-primary-800 text-xs font-medium mb-4">
              Latest Guides
            </span>
            <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-950 mb-2">
              AllChinaBuy Spreadsheet Guides
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-lg">
              Expert guides, comparisons, and tutorials to help you get the most out of your <strong>allchinabuy spreadsheet</strong>.
            </p>
          </div>
          <Link
            to="/allchinabuy-spreadsheet-guide"
            className="hidden md:inline-flex items-center gap-1.5 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap mt-4 md:mt-0"
          >
            View All Guides
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {guides.map((guide) => (
            <Link
              key={guide.title}
              to={guide.slug}
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={guide.imageUrl}
                  alt={guide.title}
                  title={guide.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 md:p-6">
                <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-900 text-xs font-medium mb-3">
                  {guide.category}
                </span>
                <h3 className="text-base font-heading font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors leading-snug mb-2">
                  {guide.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">
                  {guide.description}
                </p>
                <div className="mt-4 flex items-center gap-1.5 text-primary-500 text-xs font-medium">
                  Read Article
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-[10px]"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8 md:hidden">
          <Link
            to="/allchinabuy-spreadsheet-guide"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-500"
          >
            View All Guides
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}